// extracted by mini-css-extract-plugin
module.exports = {"relatorio":"Relatorio_relatorio__2LYeE","titulo":"Relatorio_titulo__3y-sD"};